import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-page-section',
  templateUrl: './page-section.component.html',
  styleUrls: ['./page-section.component.scss'],
})
export class PageSectionComponent {}
